import { Link } from "react-router-dom";
import { softwareList } from "@/mocks/software";
import { formatDownloads } from "@/utils/software";
import RatingStars from "@/components/base/RatingStars";

export default function HotRecommend() {
  const hot = [...softwareList].sort((a, b) => b.downloads - a.downloads).slice(0, 8);

  return (
    <section className="w-full max-w-[1240px] mx-auto px-4 md:px-6 pt-14 md:pt-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门推荐软件</h2>
          <p className="mt-1.5 text-sm text-foreground-600">根据下载量与用户关注度综合排序，发现大家都在用的中文应用</p>
        </div>
        <Link to="/category/games" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
          热门榜单
          <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-right-line" aria-hidden="true"></i></span>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {hot.map((software, i) => (
          <Link
            key={software.id}
            to={`/detail/${software.id}`}
            className="group flex items-center gap-4 bg-background-50 rounded-lg border border-background-200 p-4 transition-all duration-300 hover:border-primary-300 hover:-translate-y-0.5 animate-fade-up cursor-pointer"
            style={{ animationDelay: `${Math.min(i, 8) * 40}ms` }}
          >
            <span
              className={`flex items-center justify-center w-8 h-8 rounded-md font-heading font-bold text-sm shrink-0 ${
                i < 3 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-600"
              }`}
            >
              {i + 1}
            </span>
            <div className="w-12 h-12 rounded-lg overflow-hidden bg-background-100 border border-background-200 shrink-0">
              <img src={software.icon} alt={`${software.name} 图标`} title={`${software.name} 热门推荐`} className="w-full h-full object-cover object-top" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {software.name}
                </h3>
                <span className="text-[11px] text-primary-700 bg-primary-100 rounded-full px-1.5 py-0.5 whitespace-nowrap">v{software.version}</span>
              </div>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-1">{software.shortDesc}</p>
              <div className="mt-1.5 flex items-center gap-3 text-xs text-secondary-500">
                <RatingStars value={software.rating} showValue={false} />
                <span className="flex items-center gap-1">
                  <span className="flex items-center justify-center w-3.5 h-3.5"><i className="ri-download-2-line" aria-hidden="true"></i></span>
                  {formatDownloads(software.downloads)}
                </span>
              </div>
            </div>
            <span className="flex items-center justify-center w-5 h-5 text-secondary-300 group-hover:text-primary-500 transition-colors shrink-0">
              <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}